import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Menu } from 'antd';
import CenterDataRequestIcon from '../images/NavbarAndSidebar/centerDataRequest.svg';
import centerListingIcon from '../images/NavbarAndSidebar/centerListing.svg';
import createNewIcon from '../images/NavbarAndSidebar/createNewCenter.svg';
import featuredCentersIcon from '../images/NavbarAndSidebar/featuredCenters.svg';
import onTheFlyIcon from '../images/NavbarAndSidebar/onTheFly.svg';
import vaccinationSponsorIcon from '../images/NavbarAndSidebar/vaccinationSponsor.svg';
import plutonIcon from '../images/NavbarAndSidebar/plutonIcon.svg';
import newDoctorIcon from '../images/NavbarAndSidebar/createNewDoctor.svg';
import backArrow from '../images/NavbarAndSidebar/backArrow.svg';
import openSidebar from '../images/NavbarAndSidebar/openSidebar.svg';
import addUser from '../images/NavbarAndSidebar/addUser.svg';
import approvalRequest from '../images/NavbarAndSidebar/approvalRequest.svg';
import config from '../../config';

function SidebarComponent({
  history,
  userDetails,
  isSidebarOpen,
  toggleSidebar,
}) {
  const currentPath = history.location.pathname;

  const getMenuItemStyle = (paths) => {
    // return currentPath === path ? { backgroundColor: '#448EF7', color: 'white' } : { backgroundColor: '#041527',color: 'white' };
    return paths.includes(currentPath)
      ? { backgroundColor: '#448EF7', color: 'white' }
      : { backgroundColor: '#041527', color: 'white' };
  };

  return (
    <>
      {isSidebarOpen ? (
        <div
          className="site-layout-background"
          style={{
            position: 'sticky',
            top: '64px',
            left: 0,
            height: '100vh',
            width: '200px',
            backgroundColor: '#041527',
            overflowY: 'auto',
            zIndex: 100,
          }}
        >
          <Menu
            theme="dark"
            mode="inline"
            selectable={false}
            style={{ height: '100%', borderLeft: '0px' }}
          >
            <Menu.Item
              key="1"
              style={{ backgroundColor: '#041527', marginLeft: '130px' }}
            >
              <img
                src={backArrow}
                onClick={toggleSidebar}
                alt="back"
                style={{ width: '30px', height: '30px', paddingRight: '8px' }}
              />
            </Menu.Item>

            <Menu.Item
              key="2"
              onClick={() => history.push('/home')}
              style={getMenuItemStyle('/home')}
            >
              <img
                src={plutonIcon}
                alt="pluton"
                style={{ width: '30px', height: '20px', paddingRight: '8px' }}
              />
              Pluton
            </Menu.Item>

            <Menu.Item
              key="3"
              onClick={() => history.push('/all-centers')}
              style={getMenuItemStyle('/all-centers')}
            >
              <img
                src={centerListingIcon}
                alt="centerListing"
                style={{ width: '30px', height: '20px', paddingRight: '8px' }}
              />
              Center Listing
            </Menu.Item>

            <Menu.Item
              key="4"
              onClick={() => history.push('/on-the-fly')}
              style={getMenuItemStyle('/on-the-fly')}
            >
              <img
                src={onTheFlyIcon}
                alt="onTheFly"
                style={{ width: '30px', height: '20px', paddingRight: '8px' }}
              />
              On the Fly
            </Menu.Item>

            <Menu.Item
              key="5"
              onClick={() => history.push('/featured-centers-city')}
              style={getMenuItemStyle([
                '/featured-centers',
                '/featured-centers-city',
              ])}
            >
              <img
                src={featuredCentersIcon}
                alt="featuredCenters"
                style={{ width: '30px', height: '20px', paddingRight: '8px' }}
              />
              Featured Centers
            </Menu.Item>

            <Menu.Item
              key="6"
              onClick={() => history.push('/vaccination-sponsors')}
              style={getMenuItemStyle('/vaccination-sponsors')}
            >
              <img
                src={vaccinationSponsorIcon}
                alt="vaccinationSponsor"
                style={{ width: '30px', height: '20px', paddingRight: '8px' }}
              />
              Vaccination Sponsor
            </Menu.Item>

            <Menu.Item
              key="7"
              onClick={() => history.push('/center-data-requests')}
              style={getMenuItemStyle('/center-data-requests')}
            >
              <img
                src={CenterDataRequestIcon}
                alt="centerDataRequest"
                style={{ width: '30px', height: '20px', paddingRight: '8px' }}
              />
              Center Data Request
            </Menu.Item>

            {userDetails && userDetails.userType === 'admin' && (
              <Menu.Item
                key="8"
                onClick={() => history.push('/approval-requests')}
                style={getMenuItemStyle('/approval-requests')}
              >
                <img
                  src={approvalRequest}
                  alt="approvalRequest"
                  style={{ width: '30px', height: '20px', paddingRight: '8px' }}
                />
                Approval Requests
              </Menu.Item>
            )}

            {userDetails && userDetails.userType === 'admin' && (
              <Menu.Item
                key="9"
                onClick={() => history.push('/add-user')}
                style={getMenuItemStyle('/add-user')}
              >
                <img
                  src={addUser}
                  alt="addUser"
                  style={{ width: '30px', height: '20px', paddingRight: '8px' }}
                />
                Add user
              </Menu.Item>
            )}

            <Menu.Item
              key="10"
              onClick={() => history.push('/center-profile/new')}
              style={getMenuItemStyle('/center-profile/new')}
            >
              <img
                src={createNewIcon}
                alt="newCenter"
                style={{ width: '30px', height: '20px', paddingRight: '8px' }}
              />
              Create New Center
            </Menu.Item>

            <Menu.Item
              key="11"
              onClick={() => history.push('/doctor-profile/new')}
              style={getMenuItemStyle('/doctor-profile/new')}
            >
              <img
                src={newDoctorIcon}
                alt="newDoctor"
                style={{ width: '30px', height: '20px', paddingRight: '8px' }}
              />
              Create New Doctor
            </Menu.Item>
            {userDetails && (
              <Menu.Item
                key="12"
                onClick={() => history.push('/network-center-profile')}
                style={getMenuItemStyle('/network-center-profile')}
              >
                <img
                  src={createNewIcon}
                  alt="networkCenterProfile"
                  style={{ width: '30px', height: '20px', paddingRight: '8px' }}
                />
                Network Center Profile
              </Menu.Item>
            )}
            {userDetails && (
              <Menu.Item
                key="12"
                onClick={() => history.push('/doctor-empanelment')}
                style={getMenuItemStyle('/doctor-empanelment')}
              >
                <img
                  src={createNewIcon}
                  alt="networkCenterProfile"
                  style={{ width: '30px', height: '20px', paddingRight: '8px' }}
                />
                Network Empanelment
              </Menu.Item>
            )}
          </Menu>
        </div>
      ) : (
        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            width: '72px',
            paddingTop: '10px',
          }}
        >
          <img
            src={openSidebar}
            alt="open sidebar"
            style={{ width: '40px', height: '40px', cursor: 'pointer' }}
            onClick={toggleSidebar}
          />
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  comments: state.comments,
  user: state.user,
  verticals: state.info.verticals,
  authToken: state.user.authToken,
  userDetails: state.info.userDetails,
});

export default withRouter(connect(mapStateToProps)(SidebarComponent));
